import script from "./TokenPoolsListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./TokenPoolsListItem.vue?vue&type=script&lang=ts&setup=true"

import "./TokenPoolsListItem.vue?vue&type=style&index=0&id=4f6e3666&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f6e3666"]])

export default __exports__